/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface SeedDataSetsRequestDto
 */
export interface SeedDataSetsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof SeedDataSetsRequestDto
     */
    numberOfDataSets: number;
    /**
     * 
     * @type {number}
     * @memberof SeedDataSetsRequestDto
     */
    numberOfPointsPerDataSet: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SeedDataSetsRequestDto
     */
    evaluationDataTypeIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SeedDataSetsRequestDto
     */
    setupDataTypeIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SeedDataSetsRequestDto
     */
    $type?: SeedDataSetsRequestDtoTypeEnum;
}


/**
 * @export
 */
export const SeedDataSetsRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoSeedDataSetsRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.SeedDataSetsRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type SeedDataSetsRequestDtoTypeEnum = typeof SeedDataSetsRequestDtoTypeEnum[keyof typeof SeedDataSetsRequestDtoTypeEnum];



/**
 * Check if a given object implements the SeedDataSetsRequestDto interface.
 */
export function instanceOfSeedDataSetsRequestDto(value?: unknown): value is SeedDataSetsRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(SeedDataSetsRequestDtoTypeEnum)[0];
}

export function SeedDataSetsRequestDtoFromJSON(json: any): SeedDataSetsRequestDto {
    return SeedDataSetsRequestDtoFromJSONTyped(json, false);
}

export function SeedDataSetsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeedDataSetsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'numberOfDataSets': json['numberOfDataSets'],
        'numberOfPointsPerDataSet': json['numberOfPointsPerDataSet'],
        'evaluationDataTypeIds': json['evaluationDataTypeIds'] == null ? undefined : json['evaluationDataTypeIds'],
        'setupDataTypeIds': json['setupDataTypeIds'] == null ? undefined : json['setupDataTypeIds'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function SeedDataSetsRequestDtoToJSON(value?: SeedDataSetsRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'numberOfDataSets': value['numberOfDataSets'],
        'numberOfPointsPerDataSet': value['numberOfPointsPerDataSet'],
        'evaluationDataTypeIds': value['evaluationDataTypeIds'],
        'setupDataTypeIds': value['setupDataTypeIds'],
        '$type': value['$type'],
    });
}

